export enum PermissionConstants {
  SESSION_READ_SELF = "SESSION_READ_SELF",
  SESSION_READ_ALL = "SESSION_READ_ALL",
  SESSION_WRITE_SELF = "SESSION_WRITE_SELF",
  SESSION_WRITE_ALL = "SESSION_WRITE_ALL",
  SESSION_PUBLISH = "SESSION_PUBLISH",
  SESSION_SYNC_ADMIN = "SESSION_SYNC_ADMIN",

  SESSION_MGMT_READ_SELF = "SESSION_MGMT_READ_SELF",
  SESSION_MGMT_READ_ALL = "SESSION_MGMT_READ_ALL",
  SESSION_MGMT_WRITE_SELF = "SESSION_MGMT_WRITE_SELF",
  SESSION_MGMT_WRITE_ALL = "SESSION_MGMT_WRITE_ALL",

  SESSION_ASSIGN_TEAM = "SESSION_ASSIGN_TEAM",
  SESSION_ASSIGN_ALL = "SESSION_ASSIGN_ALL",

  VENUE_READ_SELF = "VENUE_READ_SELF",
  VENUE_READ_ALL = "VENUE_READ_ALL",
  VENUE_WRITE_SELF = "VENUE_WRITE_SELF",
  VENUE_WRITE_ALL = "VENUE_WRITE_ALL",

  TRAINING_READ = "TRAINING_READ",
  TRAINING_WRITE = "TRAINING_WRITE",

  INVENTORY_READ = "INVENTORY_READ",
  INVENTORY_WRITE = "INVENTORY_WRITE",

  ROLL_READ = "ROLL_READ",
  ROLL_CREATE = "ROLL_CREATE",
  ROLL_WRITE = "ROLL_WRITE",

  MILESTONES_READ = "MILESTONES_READ",
  MILESTONES_WRITE = "MILESTONES_WRITE",

  RFID_READ = "RFID_READ",

  AUTOGRAPHER_WRITE = "AUTOGRAPHER_WRITE",

  TEAM_UNIFORM_READ = "TEAM_UNIFORM_READ",
  TEAM_UNIFORM_WRITE = "TEAM_UNIFORM_WRITE",

  MIGRATION_READ = "MIGRATION_READ",
  MIGRATION_WRITE = "MIGRATION_WRITE",

  USER_ADMIN_READ = "USER_ADMIN_READ",
  USER_ADMIN_WRITE = "USER_ADMIN_WRITE",
}
